/* Designer Consignor Naples — flagship.js
   Premium motion layer. All effects are guarded by prefers-reduced-motion
   and pointer/hover capability. Additive to theme.js; safe if elements absent. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Scroll progress ---------- */
  function scrollProgress() {
    var bar = document.querySelector('.scroll-progress');
    if (!bar) { bar = document.createElement('div'); bar.className = 'scroll-progress'; document.body.appendChild(bar); }
    var header = document.querySelector('.header');
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      bar.style.width = (h.scrollTop / max * 100) + '%';
      if (header) header.classList.toggle('scrolled', h.scrollTop > 24);
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Reveal (groups, images, lines) ---------- */
  function reveals() {
    var els = $all('.reveal-group, .img-reveal, .lines, [data-counter]');
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); fillCounter(el, true); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); fillCounter(en.target, false); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Animated counters ---------- */
  function fillCounter(el, instant) {
    if (!el.hasAttribute || !el.hasAttribute('data-counter')) return;
    var target = parseFloat(el.getAttribute('data-counter')) || 0;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    if (instant) { el.textContent = prefix + target.toFixed(decimals) + suffix; return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Magnetic buttons ---------- */
  function magnetic() {
    if (reduced || !fine) return;
    $all('.magnetic').forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-magnetic') || '0.3');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var mx = (e.clientX - (r.left + r.width / 2)) * strength;
        var my = (e.clientY - (r.top + r.height / 2)) * strength;
        el.style.setProperty('--mx', mx + 'px');
        el.style.setProperty('--my', my + 'px');
        el.classList.add('pulling');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--mx', '0px');
        el.style.setProperty('--my', '0px');
        el.classList.remove('pulling');
      });
    });
  }

  /* ---------- Parallax ---------- */
  function parallax() {
    if (reduced) return;
    var items = $all('[data-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-parallax') || '0.12');
        var center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-center * speed) + 'px,0)';
      });
      ticking = false;
    }
    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  /* Custom cursor removed 2026-09-26 at the owner's request. */

  /* ---------- Intro veil (one-time per session) ---------- */
  function intro() {
    var veil = document.querySelector('.intro-veil');
    if (!veil) return;
    var seen;
    try { seen = sessionStorage.getItem('dcn_intro'); } catch (e) { seen = '1'; }
    if (reduced || seen) { veil.parentNode && veil.parentNode.removeChild(veil); return; }
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem('dcn_intro', '1'); } catch (e) {}
    setTimeout(function () {
      veil.classList.add('done');
      document.body.style.overflow = '';
      setTimeout(function () { veil.parentNode && veil.parentNode.removeChild(veil); }, 850);
    }, 1500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    intro();
    scrollProgress();
    reveals();
    magnetic();
    parallax();
  });
})();
